export default __webpack_public_path__ + "static/media/money-icon.41f89511.svg";